import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';

import { HoldOrderReportCriteria } from '@shared/models/report.model';
import { BaseService } from '@shared/services/base.service';
import { metricsReporting } from '@shared/utils/metrics-util';

@Injectable({
  providedIn: 'root'
})
export class HoldOrderReportService extends BaseService {
  public headers: HttpHeaders;

  constructor(
    private readonly http: HttpClient,
    protected readonly logger: NGXLogger
  ) {
    super();
    this.envService = this.env.services.holdOrderExport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public exportReport(criteria: HoldOrderReportCriteria): Observable<any> {
    const url = this.getFullUrl(this.envService.export, null);
    const metrics = metricsReporting([this.envService.export]);

    return this.http.post<any>(url, criteria, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body'
    });
  }
}
